import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconFileOpen.tsx
const OutlinedFilledFileOpen = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M878-54 767-166v117h-94v-278h278v94H833l111 111-66 68ZM511-591h220L511-811v220ZM229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h342l255 255v264H613v332H229Z" })
});
const OutlinedFileOpen = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h342l255 255v264h-95v-204H511v-220H229v662h384v94H229Zm649 1L767-166v117h-94v-278h278v94H833l111 111-66 68Zm-649-95v-662 662Z" })
});
const RoundedFilledFileOpen = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M720-327h184q19.75 0 33.38 13.68Q951-299.65 951-279.82q0 19.82-13.62 33.32Q923.75-233 904-233h-71l78 78q14 14 14.5 33.16.5 19.16-13.11 33Q898-75 878.03-74.5 858.07-74 844-88l-77-78v70q0 19.75-13.68 33.37Q739.65-49 719.82-49 700-49 686.5-62.63 673-76.25 673-96v-184q0-19.75 13.63-33.38Q700.25-327 720-327ZM511-811v173q0 19.75 13.63 33.37Q538.25-591 558-591h173L511-811Zm-282-95h302q19.44 0 37.22 8Q586-890 599-877l198 198q13 13 21 30.78t8 37.22v176q0 20.75-14.12 34.37Q797.75-387 778-387H660q-19.75 0-33.37 13.62Q613-359.75 613-340v238q0 19.75-13.62 33.37Q585.75-55 566-55H229q-39 0-66.5-27.5T135-149v-662q0-39 27.5-67t66.5-28Z" })
});
const RoundedFileOpen = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h302q19.56 0 37.28 8Q586-890 599-877l198 198q13 13 21 30.72t8 37.28v176q0 20.75-14.26 34.37-14.27 13.63-34 13.63-19.74 0-33.24-13.63Q731-414.25 731-435v-156H558q-19.75 0-33.37-13.63Q511-618.25 511-638v-173H229v662h337q19.75 0 33.38 13.68Q613-121.65 613-101.82 613-82 599.38-68.5 585.75-55 566-55H229Zm538-111v70q0 19.75-13.68 33.37Q739.65-49 719.82-49 700-49 686.5-62.63 673-76.25 673-96v-184q0-19.75 13.63-33.38Q700.25-327 720-327h184q19.75 0 33.38 13.68Q951-299.65 951-279.82q0 19.82-13.62 33.32Q923.75-233 904-233h-71l78 78q14 14.5 14.5 33.41.5 18.91-12.89 32.75Q898-75 878.23-74.5 858.47-74 844-88l-77-78Zm-538 17v-662 662Z" })
});
const SharpFilledFileOpen = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M878-54 767-166v117h-94v-278h278v94H833l111 111-66 68ZM511-591h220L511-811v220ZM135-55v-851h436l255 255v264H613v332H135Z" })
});
const SharpFileOpen = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M135-55v-851h436l255 255v264h-95v-204H511v-220H229v662h384v94H135Zm743 1L767-166v117h-94v-278h278v94H833l111 111-66 68Zm-649-95v-662 662Z" })
});
const componentMap = {
	outlined: OutlinedFileOpen,
	"outlined-fill": OutlinedFilledFileOpen,
	rounded: RoundedFileOpen,
	"rounded-fill": RoundedFilledFileOpen,
	sharp: SharpFileOpen,
	"sharp-fill": SharpFilledFileOpen
};
const IconFileOpen = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconFileOpen };